<template>
    <div class="adress-page" v-if="$store.state.main.userData !== null" >
        <div class="inner-addres cartContainer">
            <!-- {{$store.state.main.userData}} -->
            <div class="item-cont">
            <button class="back" @click="back">
                <div class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20.62" height="15.07" viewBox="0 0 20.62 15.07">
                        <g id="Group_104" data-name="Group 104" transform="translate(0.534 0.535)">
                            <g id="menu" transform="translate(0 0)">
                            <g id="Group_103" data-name="Group 103" transform="translate(0 0)">
                                <path id="Union_6" data-name="Union 6" d="M9.062.879a37.229,37.229,0,0,0,4.729,3.3c.457.271.925.53,1.407.755-.7.029-1.409,0-2.113-.029-.748-.031-1.487-.06-2.194-.025-3.048.165-6.065.724-9.125.666-1.052-.017-2.779,1.559-1,1.592,3.468.064,6.869-.624,10.328-.7.573-.011,1.159,0,1.752.016a19,19,0,0,0,3.911-.186,56.985,56.985,0,0,0-5.136,5.369c-.442.6-.091,1.6.513.767,1.772-2.432,4.258-4.2,6.158-6.521a1,1,0,0,0,.158-.271.794.794,0,0,0,.25-.608c0-.027,0-.052,0-.075-.015-.457-.669-.551-1.321-.4A9.019,9.019,0,0,1,13.969,2.97a41.86,41.86,0,0,1-3.9-2.78A.9.9,0,0,0,9.5,0C8.967,0,8.481.4,9.062.879Z" transform="matrix(-0.998, -0.07, 0.07, -0.998, 18.659, 14.001)" fill="#101820" stroke="#101820" stroke-width="1"/>
                            </g>
                            </g>
                        </g>
                        </svg>
                </div>
                <p class="bolg-italic">{{ $fn.tr('უკან') }}</p>
            </button>
            <p class="title regular">{{$fn.tr('მიწოდების მისამართი')}}</p>
            <transition name="fade">
            <div v-if="$store.state.main.adressCartsRender">
            <adressItem v-for="(item, index) in addressArr" :key="index" :data2="item" :id="item.id" />
            </div>
            </transition>
            <slide-up-down :active="active" :duration="600">
            <div class="add-form">
            <form @submit.prevent="addNewAdressValid" novalidate>
            <p class="ttl bold-italic">{{ $fn.tr('ახალი მისამართი') }}</p>
            <div class="inp">
                <input type="text" v-model="data.name" :placeholder="$fn.tr('სახელი და გვარი')" />
                <transition name="fade">
                <p class="err regular" v-if="data.err.nameErr">{{ $fn.tr('შეიყვანეთ სახელი და გვარი!') }}</p>
                </transition>
            </div>
            <div class="inp">
                <input type="text" @keypress="dontNum($event)" v-model="data.phone" :placeholder="$fn.tr('ტელ.ნომერი')" />
                <transition name="fade">
                <p class="err regular" v-if="data.err.phoneErr">{{ $fn.tr('შეიყვანეთ ტელ.ნომერი') }}</p>
                </transition>
            </div>
            <div class="inp-select">
                <el-select v-model="data.citys" :placeholder="$fn.tr('ქალაქი')">
                <el-option
                v-for="item in city_list"
                :key="item.id"
                :label="item.title"
                :value="item.slug"
                >
                </el-option>
            </el-select>
            <transition name="fade">
            <p class="err regular" v-if="data.err.citysErr">{{ $fn.tr('აირჩიეთ ქალაქი!') }}</p>
            </transition>
            </div>
            <div class="inp">
                <input type="text" v-model="data.adress" :placeholder="$fn.tr('მისამართი')" />
                <transition name="fade">
                <p class="err regular" v-if="data.err.adressErr">{{ $fn.tr('შეიყვანეთ მისამართი!') }}</p>
                </transition>
            </div>
            <div class="but-cont">
            <button class="save">
                <img src="@/assets/img/buybtn.png" />
                <p class="regular">{{ $fn.tr('შენახვა') }}</p>
            </button>
            <div class="close" @click="active = null">
                <img src="@/assets/img/closeBorder.png" />
                <p class="regular">{{ $fn.tr('გაუქმება') }}</p>
            </div>
            </div>
            </form>
            </div>
            </slide-up-down>
            <transition name="fade">
            <button class="add" @click="openSlide" v-if="active === null">
                <img src="@/assets/img/adressBut.png" />
                <div class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="19.919" height="19.711" viewBox="0 0 19.919 19.711">
                    <g id="Group_1828" data-name="Group 1828" transform="translate(-1123.776 -866.017)">
                        <path id="Path_219" data-name="Path 219" d="M5.179,22.785c3.466.064,6.869-.624,10.326-.7,2.115-.044,4.418.254,6.483-.368.513-.154,1.145-.451,1.124-1.067l0-.075c-.02-.6-1.129-.575-1.9-.195-1.88.431-4.016.044-5.909.145-3.048.163-6.065.723-9.124.666C5.122,21.175,3.4,22.752,5.179,22.785Z" transform="matrix(-0.998, -0.07, 0.07, -0.998, 1145.963, 898.233)" fill="#fff" stroke="#fff" stroke-width="1"/>
                        <path id="Path_3800" data-name="Path 3800" d="M5.179,22.785c3.466.064,6.869-.624,10.326-.7,2.115-.044,4.418.254,6.483-.368.513-.154,1.145-.451,1.124-1.067l0-.075c-.02-.6-1.129-.575-1.9-.195-1.88.431-4.016.044-5.909.145-3.048.163-6.065.723-9.124.666C5.122,21.175,3.4,22.752,5.179,22.785Z" transform="translate(1155.184 862.115) rotate(90)" fill="#fff" stroke="#fff" stroke-width="1"/>
                    </g>
                    </svg>
                </div>
                <p class="regular">{{ $fn.tr('დაამატე მისამართი') }}</p>
            </button>
            </transition>
            </div>
            <cartResultCounter />
        </div>
    </div>
</template>

<script>
import cartResultCounter from '@/components/smartComponents/cartResultCounter.vue';
import SmoothScroll from '@/components/SmoothScroll';
import adressItem from '@/components/adressItem';
import { mapGetters } from 'vuex';
export default {
    components: {
        cartResultCounter,
        SmoothScroll,
        adressItem
    },
    data() {
        return {
            active: null,
            addressArr: [],
            data: {
                name: '',
                phone: '',
                citys: '',
                adress: '',
                err: {
                    nameErr: false,
                    phoneErr: false,
                    citysErr: false,
                    adressErr: false,
                }
            }
        }
    },
    mounted() {
        if (localStorage.getItem('userToken') === 'null') {
            this.$store.state.main.locale == 'ge' ? this.$router.push('/ge/cart')
            : this.$router.push('/en/cart');
        }
        if(this.$store.state.main.userData !== null)this.addressArr = this.addresses.address;
        setTimeout(() => {
            
        }, 1000);
        console.log(this.addresses)
        console.log(this.userDataStore)

    },
    watch: {
        active(){
                setTimeout(() => {
               this.$store.state.main.updateLs = !this.$store.state.main.updateLs
            }, 620);
        },

            userDataStore(ns, os){
                console.log(ns)
        this.addressArr = this.addresses.address;
        if(ns !== null){
          this.$store.state.main.cabinetLoaded = true;
        }
      },
      addressArr(ns, os){
          console.log(ns)
      },
      addresses(ns, os){
          console.log(ns)
      },
      renderCart(ns, os){
          console.log(this.$store.state.main.userData);
          this.addressArr = this.addresses.address;
      }
    },
    computed: {
        renderCart(){
            return this.$store.state.main.adressCartsRender;
        },
        ...mapGetters({ addresses: "main/returnUser" }),

        userDataStore(){
        return this.$store.state.main.userData;
        },
        city_list() {
            return this.$store.state.main.indx.terms.customer_cities;
        }
    },
    methods: {
        back() {
            this.$store.state.main.locale == 'ge' ? this.$router.push('/ge/cart')
            : this.$router.push('/en/cart');
        },
        dontNum(event) {  
        if (event.keyCode == 46 || event.keyCode == 8)
        {
        //do nothing
        }
        else 
        {
            if (event.keyCode < 48 || event.keyCode > 57 ) 
            {
			    event.preventDefault();	
			}	
        }
        },
         getCityTranslate(item){
            let cc = this.$store.state.main.indx.terms.customer_cities;
            cc = cc.filter(c => c.slug == item );
            return cc[0].title;
        },
        addNewAdressValid() {
            if (this.data.name === '') {
                this.data.err.nameErr = true
            } else if (this.data.phone === '') {
                this.data.err.phoneErr = true
            } else if (this.data.citys === '') {
                this.data.err.citysErr = true
            } else if (this.data.adress === '') {
                this.data.err.adressErr = true
            } else {
                this.data.err.nameErr = false
                this.data.err.phoneErr = false
                this.data.err.citysErr = false
                this.data.err.adressErr = false
                this.addNewAdress()
            }
        },
        async addNewAdress() {
             let data = {};
            data.main_adress = null;
            data.name = this.data.name;
            data.phone = this.data.phone;
            data.city = this.data.citys;
            data.street = this.data.adress;
            data.house = null;
            data.entrance = null;
            data.floor = null;
           
            let tmp = await this.$fn.postData('user/addaddress', {data: data, token: localStorage.userToken});
            this.$store.commit("main/changeAddress", tmp.data.addresses);
            this.addressArr = this.addresses.address;
            this.active = null
            setTimeout(() => {
                    this.scrollStatus();
            }, 600);
        },
        openSlide() {
            this.active = true
        
        }
    }
}

</script>

<style>
.adress-page {
    padding-bottom: 244px;
    min-height: 100vh;
}
.adress-page .err {
    position: absolute;
    bottom: -22px;
    left: 0;
    color: red;
    font-size: 12px;
}
.adress-page .back {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 34px;
    backface-visibility: hidden;
    will-change: transform;
    transition: 0.6s;
}
.adress-page .back .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
}
.adress-page .back p {
    font-size: 21px;
    color: #101820;
}
.adress-page .inner-addres .item-cont .title {
    font-size: 34px;
    color: #BACB32;
    margin-bottom: 34px;
}
.adress-page .add-form input {
    font-family: "FiraGO-Bold";
    color: #101820;
    font-size: 21px;
}
.adress-page .add-form {
    margin-top: 40px;
}
.adress-page .add-form .ttl {
    margin-bottom: 34px;
}
.adress-page .add-form .but-cont {
    display: flex;
    align-items: center;
}
.adress-page .add-form .but-cont .save {
    margin-right: 32px;
}
.adress-page .add-form .but-cont .save,
.adress-page .add-form .but-cont .close {
    position: relative;
    width: 187px;
    height: 54px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    backface-visibility: hidden;
    will-change: transform;
    transition: 0.6s;
}
.adress-page .add-form .but-cont .save img,
.adress-page .add-form .but-cont .close img  {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
}
.adress-page .add-form .but-cont .save p,
.adress-page .add-form .but-cont .close p  {
    font-size: 21px;
    color: #BACB32;
    z-index: 2;
}
.adress-page .add-form .inp {
    position: relative;
    width: 100%;
    height: 40px;
    margin-bottom: 55px;
}
.adress-page .add-form .inp-select {
    margin-bottom: 55px;
    position: relative;
}
.adress-page .add-form .inp-select .el-select { 
    width: 100%;
}
.adress-page .add-form .inp-select .el-input--suffix .el-input__inner {
    padding-bottom: 13px;
    border-color: #101820;
    border-bottom: 1px solid #101820;
    border-top: none;
    border-left: none;
    border-right: none;
    padding-left: 0;
    border-radius: 0;
}
.adress-page .add-form .inp input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding-bottom: 13px;
    border-color: #101820;
    border-bottom: 1px solid #101820;
    border-top: none;
    border-left: none;
    border-right: none;
    padding-left: 0;
    border-radius: 0;
}
.adress-page .inner-addres {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
.adress-page .add-form .ttl {
    color: #BACB32;
    font-size: 21px;
}
.adress-page .add {
    width: 350px;
    height: 58px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 34px;
    transition: 0.6s;
    backface-visibility: hidden;
    will-change: transform;
}
.adress-page .add img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.adress-page .add .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 15px;
    position: relative;
}
.adress-page .add p {
    font-size: 21px;
    color: #FFFFFF;
    position: relative;
}
.adress-page .inner-addres .item {
    width: 540px;
    position: relative;
    border-top: 2px solid #D7DEED;
    border-bottom: 2px solid #D7DEED;
    padding-top: 28.8px;
    padding-bottom: 19px;
    display: flex;
    /* align-items: center; */
    margin-top: -2px;
}
.adress-page .inner-addres .item .check-cont {
    position: relative;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.adress-page .inner-addres .item .check-cont .bg-icon {
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    background-color: white;
    z-index: 2;
}
.adress-page .inner-addres .item .check-cont .check-icon {
    position: absolute;
    top: -1px;
    left: 61%;
    flex: none;
    transform: translateX(-50%);
    z-index: 4;
    pointer-events: none;
    opacity: 0;
    transition: 0.6s;
}
.adress-page .inner-addres .item .check-cont .el-checkbox {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 95%;
    z-index: 1;
    height: 95%;
}
.adress-page .inner-addres .item .check-cont .el-checkbox.is-checked ~ .check-icon {
    opacity: 1;
}
.adress-page .inner-addres .item .check-cont .el-checkbox__inner {
    width: 100%;
    height: 100%;
}
.adress-page .inner-addres .item:first-child {
    margin-top: 0px;
}
.adress-page .inner-addres .item .data-cont {
    margin-left: 20px;
    width: 100%;
}
.adress-page .inner-addres .item .change {
    font-size: 13px;
    color: #FDCF18;
    margin-top: 5px;
}
.adress-page .inner-addres .item .name {
    font-size: 21px;
    color: #101820;
    margin-top: 21px;
}
.adress-page .inner-addres .item .country, .adress-page .inner-addres .item .city, 
.adress-page .inner-addres .item .phone:not(.adress-page .inner-addres .item .phone) {
    font-size: 16px;
    color: #101820;
    margin-bottom: 6px;
}
.adress-page .inner-addres .item .country {
    margin-top: 8px;
}
@media (min-width: 1024px) {
    .adress-page .add:hover, .adress-page .add-form .but-cont .save:hover, 
    .adress-page .add-form .but-cont .close:hover, .adress-page .back:hover {
        transform: scale(1.1) rotate(-2deg);
    }
}
@media (max-width: 1023px) {
    .adress-page .inner-addres {
        flex-direction: column;
    }
    .adress-page .inner-addres .item,
    .adress-page .inner-addres .item-cont {
        width: 100%;
    }
}
</style>